import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "../../styles/ReactToastify.css";

export default function Products({
  handleCartUpdate,
  categoryProducts,
  reachedMax,
  setReachedMax,
  searchedProducts,
}) {
  const [products, setProducts] = useState([]);
  const location = useLocation();
  const category = new URLSearchParams(location.search).get("category");
  const search = new URLSearchParams(location.search).get("search");

  useEffect(() => {
    if (category !== null && search === null) {
      // console.log("cPP", categoryProducts);
      if (Object.keys(categoryProducts).length !== 0) {
        const requiredCategory = Object.keys(categoryProducts).filter(
          (item) => item === category
        );

        const filteredProducts = requiredCategory.map(
          (item) => categoryProducts[item]
        );
        setProducts(filteredProducts[0]);
      }
    } else if (category === null && search !== null) {
      setProducts(searchedProducts);
    }
  }, [category, categoryProducts, searchedProducts]);

  // Shows side toast on adding to cart
  useEffect(() => {
    if (reachedMax !== 0) {
      if (reachedMax === 200) {
        // console.log("Showing toast 200");
        toast.success("Added to Cart!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else if (reachedMax === 500) {
        // console.log("Showing toast 500");
        toast.error("Already max quantity in cart", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      setReachedMax(0);
    }
  }, [reachedMax]);

  return (
    <div className="container">
      {search && (
        <h1 className="mt-10 text-xl md:text-2xl font-semibold">
          Search Results for:{" "}
          <span className="text-ambhosOrange">{search}</span>
        </h1>
      )}
      {category && (
        <h1 className="mt-10 text-2xl text-ambhosOrange font-semibold">
          {category}
        </h1>
      )}
      {products?.length > 0 && products[0] !== undefined ? (
        <div className="mt-10 w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
          {products.map((product) => (
            <div key={product?._id} className="">
              <ProductCard
                id={product?._id}
                image={product?.images ? product?.images[0] : ""}
                title={product?.productName}
                brand={product?.brandName}
                color={product?.color}
                sizes={product?.availableSize ? product?.availableSize : []}
                rating={product?.rating ? product?.rating : ""}
                price={product?.price}
                mrp={product?.mrp}
                handleCartUpdate={handleCartUpdate}
                reachedMax={reachedMax}
                setReachedMax={setReachedMax}
              />
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center h-72">
          <p className="font-semibold text-lg">Coming Soon!</p>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}
